import { CellBadgeListRenderer } from '@casops/components/tables/cells/CellBadgeListRenderer';
import i18n from '@casops/i18n';
import { AssetDeviceType } from '@casops/store/apis/registeredAssetsApi';
import { ValueGetterFunc, ValueGetterParams } from 'ag-grid-community';
import { CustomCellRendererProps } from 'ag-grid-react';
import { ReactElement } from 'react';
import { EmptyCell } from '../../formatters/genericFormatters';

// Convert the cell value from an enum to a translation (for searching/sorting).
export const assetDeviceTypeValueGetter = <TData extends { hw: AssetDeviceType }>({
  data,
}: ValueGetterParams<TData, string>): ReturnType<ValueGetterFunc<TData, string>> => {
  return typeof data?.hw === 'string' ? i18n.t(`AssetDeviceType.${data.hw}`) : null;
};

export const AssetDeviceTypeCellRenderer = ({
  value,
}: CustomCellRendererProps<object, string>): ReactElement | string => {
  return value ? <CellBadgeListRenderer value={value} statusColor="neutral" /> : EmptyCell;
};
